module.exports = __webpack_public_path__ + "img/Psycore.8217318a.webp";